import { useTheme } from '../context/ThemeContext';
import { API_BASE } from '../config';
import { ExpandIcon } from './IconSet';
import './PropertyStaticMapPreview.css';

// A static, non-interactive preview for the "Property location" section -
// clicking it opens the full interactive map (PropertyGoogleMap.js) in the
// fullscreen gallery. The image itself is proxied through the server
// (GET /geocode/static-map) rather than hitting Google's Static Maps API
// directly, so the request never needs a client-exposed key for this call.
function PropertyStaticMapPreview({ latitude, longitude, address, onClick }) {
  const { isDarkMode } = useTheme();
  const hasValidCoords = Number.isFinite(latitude) && Number.isFinite(longitude);

  if (!hasValidCoords) {
    return (
      <div className="property-map-shell">
        <div className="map-empty-state map-empty-state--standalone">
          <p>Map location not available for this property.</p>
          <small>The listing&apos;s address hasn&apos;t been pinned to a location yet.</small>
        </div>
      </div>
    );
  }

  const imageUrl = `${API_BASE}/geocode/static-map?lat=${latitude}&lon=${longitude}&theme=${
    isDarkMode ? 'dark' : 'light'
  }`;

  return (
    <button
      type="button"
      className="property-static-map-preview"
      onClick={onClick}
      aria-label={`Open interactive map${address ? ` for ${address}` : ''}`}
    >
      <img src={imageUrl} alt="Map preview of the property's location" loading="lazy" />
      <span className="property-static-map-preview__cta">
        <ExpandIcon size={14} />
        <span className="property-static-map-preview__cta-label">Explore interactive map</span>
      </span>
    </button>
  );
}

export default PropertyStaticMapPreview;
